export const tickets = [
  {
    id: "PC-2025-001",
    title: "Request for Flexible Work Hours",
    submittedBy: "Ashley Palma",
    priority: "medium",
    status: "open",
    category: "Work-Life Balance",
    description: "Would like to discuss adjusting work hours to accommodate personal commitments.",
    replies: 2,
    lastUpdated: "1 hour ago"
  },
  {
    id: "PC-2025-002",
    title: "Team Building Activity Suggestion",
    submittedBy: "Saccharine Elupre",
    priority: "low",
    status: "in-progress",
    category: "Engagement",
    description: "Suggesting a monthly team building activity to improve collaboration.",
    replies: 5,
    lastUpdated: "4 hours ago"
  },
  {
    id: "PC-2025-003",
    title: "Professional Development Request",
    submittedBy: "Emily Rodriguez",
    priority: "high",
    status: "open",
    category: "Learning",
    description: "Requesting approval to attend a design conference next month.",
    replies: 1,
    lastUpdated: "30 mins ago"
  },
  {
    id: "PC-2025-004",
    title: "Workplace Conflict Resolution",
    submittedBy: "James Wilson",
    priority: "high",
    status: "in-progress",
    category: "HR Support",
    description: "Need assistance with resolving a team communication issue.",
    replies: 8,
    lastUpdated: "2 days ago"
  },
  {
    id: "PC-2025-005",
    title: "Benefits Inquiry",
    submittedBy: "Lisa Anderson",
    priority: "medium",
    status: "resolved",
    category: "Benefits",
    description: "Questions about health insurance coverage options.",
    replies: 4,
    lastUpdated: "3 days ago"
  }
];
